const PlusIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <g id="Group_8171" data-name="Group 8171" transform="translate(-600.5 -1302)">
                <line
                    id="Line_253"
                    data-name="Line 253"
                    x2="15"
                    transform="translate(600.5 1309.5)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                />
                <line
                    id="Line_254"
                    data-name="Line 254"
                    y2="15"
                    transform="translate(608 1302)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                />
            </g>
        </svg>
    );
};

export default PlusIcon;
